/*
    Module definition for browserify
*/
require('./dist/filepicker');
module.exports = filepicker;



//////////////////
// WEBPACK FOOTER
// ./~/filepicker-js/index.js
// module id = 1502
// module chunks = 0